/* eslint-disable no-irregular-whitespace */
/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { css } from 'styled-components';
import BaseLayout from '../common/layouts/BaseLayout';
import HeadShared from '../common/HeadShared';
import HeroLanding from '../common/layouts/heroLanding';
import { Container, Padding, Margin } from '../common/base';
import { Grid, Col } from '../common/interfaces';
import { LegalSubtitle, LegalDesc, LegalHeader, LegalList } from './Styled';

import { Trans } from '../common/libs/i18n';

const PrivacyPolicyDocument = () => (
  <BaseLayout headerType="red">
    <HeadShared title="RupiahToken - Privacy Policy" desc="Privacy Policy" />
    <HeroLanding title="Privacy Policy" />
    <div
      css={css`
        background-color: ${({ theme: { colors } }) => colors.light.primary};
      `}
    >
      <Container>
        <Padding vertical={80}>
          <Grid justify="center">
            <Col lg={8} sm={12}>
              <Margin bottom={60}>
                <Trans i18nKey="rupiahtoken.privacy_policy_document">
                  <h2>Rupiah Token Privacy Policy</h2>
                  <LegalSubtitle>Last updated: June 20, 2019</LegalSubtitle>
                  <LegalDesc>
                    <LegalHeader>Introduction</LegalHeader>
                    <p>
                      <b>PT Rupiah Token Indonesia</b>
                      &nbsp;("Company," "our," "we") understands the importance of privacy,
                      especially when it comes to your personal information. Data privacy and your
                      trust are our top priorities, and in this Privacy Policy we explain what
                      information we collect from you when you register to our website (the
                      "Application") and use our online asset tokenization platform
                      (the "Platform"). Please read this policy carefully to understand our policies
                      and practices regarding your information, as you agree to this Privacy Policy
                      by using the Platform.
                      <b>
                        If you do not agree with our policies and practices, do not use the Platform
                      </b>
                      .&nbsp;This Privacy Policy is part of our
                      <a href="./terms">Terms of Use</a>
                      .&nbsp;
                    </p>
                    <Margin top={24}>
                      <LegalHeader>What Information Does RupiahToken Collect From You?</LegalHeader>
                      <p>
                        We collect several types of information from and about users of the Platform
                        and Application, including:
                        <LegalList>
                          <li>
                            Your personal information (such as your name, address, phone number, and
                            email address)
                          </li>
                          <li>
                            Your financial information, such as bank accounts and/or cryptocurrency
                            wallet addresses;
                          </li>
                          <li>
                            Your information that is needed to complete a Know Your Customer
                            (KYC) &amp; Anti-money Laundering (AML) check
                          </li>
                          <li>
                            Any other information you voluntarily provide on the Platform or
                            Application in the ordinary course of the continuation of the
                            relationship
                          </li>
                          <li>
                            Information about your internet connection, the equipment you use to
                            access the Platform, Application, as well as Platform and Application
                            usage details.
                          </li>
                        </LegalList>
                      </p>
                    </Margin>
                    <Margin top={24}>
                      <LegalHeader>How Does RupiahToken Collect Your Information?</LegalHeader>
                      <p>
                        We collect information from you in two ways:
                        <LegalList>
                          <li>
                            First, we collect information directly from you when you provide it to
                            us, such as signing up for an account, or entering information into the
                            Platform or Application when prompted/asked.
                          </li>
                          <li>
                            Second, we collect generic information about your usage and equipment
                            automatically as you navigate through the Platform and Application, such
                            as usage details, IP addresses, web browser preferences, and information
                            collected through cookies and other tracking technologies. We do not
                            correlate tracking information to individuals, but some information
                            collected, such as IP addresses, will be unique.
                          </li>
                        </LegalList>
                      </p>
                    </Margin>
                    <Margin top={24}>
                      <LegalHeader>How Does RupiahToken Use Your Information?</LegalHeader>
                      <p>
                        We use information that we collect about you or that you provide to us,
                        including personal information, for the following uses:
                        <LegalList>
                          <li>
                            To continue the daily operation of the services and facilities provided
                            to customers
                          </li>
                          <li>
                            To notify you about changes to the Platform and Application or any
                            products or services we offer or provide though them
                          </li>
                          <li>
                            To provide you with information, products, or services that you request
                            from us.
                          </li>
                          <li>
                            To verify the information that you provide, and validate you through the
                            KYC/AML process required by us and our fiduciary partners.
                          </li>
                          <li>
                            To comply with required disclosure requests from regulatory or other
                            authorities with which the Platform and Application are expected to
                            comply.
                          </li>
                          <li>
                            In any other way we may describe when you provide the information.
                          </li>
                        </LegalList>
                      </p>
                    </Margin>
                    <Margin top={24}>
                      <LegalHeader>Changes to Our Privacy Policy</LegalHeader>
                      <p>
                        We will post any changes we make to our privacy policy on this page. To ask
                        questions or comment about this Privacy Policy and our privacy practices,
                        contact us at&nbsp;
                        <a href="mailto:support@rupiahtoken.com">support@rupiahtoken.com</a>
                      </p>
                    </Margin>
                  </LegalDesc>
                </Trans>
              </Margin>
            </Col>
          </Grid>
        </Padding>
      </Container>
    </div>
  </BaseLayout>
);

export default PrivacyPolicyDocument;
